export class WireInstructionConfirmationApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getWireInstructionConfirmation({ loanId }) {
    return this.#http.get(`/api/loans/${loanId}/wire-instruction-confirmation`);
  }
}
